module.exports = __webpack_public_path__ + "static/media/house-6.ee021f8a.jpeg";